/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");

var DISCONNECT_DELAY = 32 * 1000;

module.exports = new Model({
	name: "braceletdisconnector",
	init: init,
	uninit: uninit,
	listeners: listeners,

	cancel_disconnect: cancel_disconnect,

	_bracelets: null,
});

function init() {
	this._bracelets = {};
}

function uninit() {
	this._bracelets = null;
	this.cancel_disconnect();
}

function listeners() {
	return {
		"bracelets:updated": handle_bracelets_updated,
		"connectivity:online": cancel_disconnect,
		"connectivity:offline": handle_disconnected
	};
}

function handle_bracelets_updated(bracelets) {
	this._bracelets = bracelets;
}

function cancel_disconnect() {
	if (!this._timer) return;
	clearTimeout(this._timer);
	this._timer = null;
}

function handle_disconnected() {
	this._timer = setTimeout(disconnectAll.bind(this), DISCONNECT_DELAY);
}

function disconnectAll() {
	var bracelets = this._bracelets;
	Object.keys(bracelets).forEach(function (bracelet) {
		if (!bracelets[bracelet]) return;

		this.emit("bluetooth:trigger:disconnect", {
			mac: bracelet
		});
	}, this);
}
